import * as angular from 'angular';
import {RootScope} from '../types/angular-types';
import Features from '../feature-manager/Features';
import AppConstants from '../gorillaboy/AppConstants';
import {ISelectedItem} from '../types/selectionManager'
import {ApprovalDetailsService} from '../approvals/approvals-types';
import {IApprovalUtils} from '../approvals/ApprovalUtils';
import { CompanionClientService } from "../companionClient/companionClient";

import '../tasks/access_request/accessRequestModalController';
import '../tasks/access_request/accessRequestModal.html'
import './buttons/request_access_button.html';

const getCreateApprovalURIPrefix = function () {
    const path = window.location.pathname;
    const approvalAppLinkPrefix = path.substring(0, path.lastIndexOf("/"));
    const createRouteURI_for_approvalApp = approvalAppLinkPrefix + "/approvals/index.html#/createApproval";

    return createRouteURI_for_approvalApp;
}

function isCreateApprovalButtonVisible(resource, $scope, $rootScope, authenticatedUser) {
    const parentFolderURL = $scope.getParentFolderURL(resource);
    const isFileRecycled = parentFolderURL.startsWith('#/recovery') || parentFolderURL.startsWith('#/recycle');

    return !isFileRecycled && !authenticatedUser.getUserInfo().MinimalUser &&
        !$rootScope.isFeatureEnabled(Features.UI.APPROVAL_V2_DISABLED);
};

angular.module('GorillaBoy.directives')
    .directive('verticalDivider', [
        '$rootScope',
        function viewButton($rootScope: RootScope) {
        return {
            template: '<span style="bottom: 10%;height: 80%;border-left: 1px solid #E0E0E0;box-sizing: border-box; font-size: initial;"></span>',
        };
    }])
    .directive('folderInfoButton', [
        '$rootScope',
        function folderInfoButton($rootScope: RootScope) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/folderInfo_button.html',
            scope: {
                enabled: '<',
                onClicked: '&'
            },
            link: function($scope, $element, attrs) {

            }
        };
    }])
    .directive('editButton', [
        '$rootScope',
        '$uibModal',
        '$translate',
        'AppConstants',
        'authenticatedUser',
        'BrowserService',
        'ContentTypeFormatter',
        'CompanionClientService',
        'CompanionService',
        'FeatureManagerService',
        'EndpointConfig',
        function editButton($rootScope: RootScope, $uibModal, $translate, AppConstants, authenticatedUser, BrowserService, ContentTypeFormatter, CompanionClientService: CompanionClientService, CompanionService, FeatureManagerService, EndpointConfig) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/edit_button.html',
            scope: {
                enabled: '<',
                document: '<',
                userActionsMap: '<',
                getEditDisabledReason: '&'
            },
            link: function($scope, $element, attrs) {
                /* CAUTION: there are a few instances calling "$parent". This is not a good practice.
                 * However, we use it here to avoid refactoring the related code too much. Do not follow
                 * this link function as an example.
                 */

                /* Office 365 helper functions */
                $scope.getO365DisabledTooltip = function(doc) {
                    if ($rootScope.isO365FeatureEnabled()) {
                        if (!$rootScope.office365EditingEnabled) {
                            return $translate.instant('TOP_NAV.OPEN_WITH_OFFICE_DISABLED_TOOLTIP');
                        } else if ($scope.userActionsMap[$scope.document.Id].isOfficeLegacyFile) {
                            return $translate.instant('O365_OPTION_DISABLED_REASON');
                        } else if ($scope.$parent.isDocumentCheckedOut(doc) && !$scope.$parent.isDocumentCheckedOutByO365(doc)) {
                            return $translate.instant('O365.OPTION_DISABLED_DUE_TO_LOCK');
                        }
                    }
                    return '';
                };

                $scope.isO365ActionEnabled = function() {
                    var document = $scope.document,
                        userActionsMap = $scope.userActionsMap;
                    return userActionsMap[document.Id] && userActionsMap[document.Id].canEditWithO365;
                };

                $scope.isO365ActionGrayedout = function() {
                    var document = $scope.document,
                        userActionsMap = $scope.userActionsMap;
                    return userActionsMap[document.Id] &&
                        (!userActionsMap[document.Id].canEditWithO365 ||
                         $scope.$parent.isO365EditingOptionDisabled(document));
                };

                $scope.showO365Action = function() {
                    return $scope.isO365ActionEnabled() ||
                        //It will be disabled, but we still show it
                        $scope.isO365ActionGrayedout();
                };

                $scope.getO365ActionTooltip = function() {
                    var msgKey;
                    var document = $scope.document;

                    if ($scope.$parent.isDocumentCheckedOutByO365(document)) {
                        return $translate.instant('EXTERNAL_EDIT.LIVE_EDIT_IN_PROGRESS');
                    } else if ($scope.isO365ActionGrayedout()) {
                        return $scope.getO365DisabledTooltip(document);
                    } else if ($scope.isO365ActionEnabled()) {
                        return $translate.instant('TOP_NAV.OPENWITHOFFICE');
                    }
                };

                $scope.currentLocationHash = encodeURIComponent(window.location.hash);

                /* Hancom helper functions */
                $scope.showHancomButton = function() {
                    var isDeviceSupported = !BrowserService.isMobileOrTablet();
                    return $rootScope.isFeatureEnabled($rootScope.Features.DocumentViewer.ONLINEEDITING) && $rootScope.onlineEditingEnabled && isDeviceSupported;
                };

                $scope.editOnline = $scope.$parent.editOnline;

                /* Companion helper functions */
                function showEditButton() {
                    var isDeviceSupported = !BrowserService.isMobileOrTablet(),
                        isOSSupported = [AppConstants.OSTypes.WINDOWS, AppConstants.OSTypes.MAC].indexOf(BrowserService.getOS()) > -1,
                        editEnabled = $rootScope.isFeatureEnabled($rootScope.Features.UI.FRICTIONLESS_EDIT);

                    return editEnabled && isOSSupported && isDeviceSupported;
                };

                function isDesktopAppEditEnabled() {
                    return $rootScope.isFeatureEnabled($rootScope.Features.Desktop.DESKTOP_APP_EDIT);
                }

                $scope.showEditDriveButton = function() {
                    return showEditButton() && isDesktopAppEditEnabled() && $rootScope.isFeatureEnabled($rootScope.Features.UI.COMPANION_TERMINATION_SWITCH);
                };
                $scope.showEditDriveButtonNew = function() {
                    return showEditButton() && isDesktopAppEditEnabled() && !$rootScope.isFeatureEnabled($rootScope.Features.UI.COMPANION_TERMINATION_SWITCH);
                };

                $scope.showEditCompanionButton = function() {
                    return showEditButton() && !isDesktopAppEditEnabled();
                };

                $scope.showEditCompanionRetiringButton = function() {
                    return showEditButton() && isDesktopAppEditEnabled() && $rootScope.isFeatureEnabled($rootScope.Features.UI.COMPANION_TERMINATION_SWITCH);
                };

                $scope.openInFrictionlessEdit = $scope.$parent.openInFrictionlessEdit;

                $scope.featureNotificationEditDescription = function() {
                    return $translate.instant('FEATURE_NOTIFICATION.DRIVE.DESCRIPTION');
                };

                $scope.featureNotificationEditTitle = function() {
                    return $translate.instant('FEATURE_NOTIFICATION.DRIVE.TITLE');
                };
                
                /* Overall functions */
                $scope.atLeastOneAvailableOption = function() {

                    // for minimal users edit is not allowed.
                    if(authenticatedUser.getUserInfo().MinimalUser){
                        return false;
                    }

                    return $scope.showO365Action() ||
                        showEditButton() ||
                        $scope.showHancomButton();
                }

                $scope.goto = $rootScope.goto;

                $scope.previouslyConnected = () => {
                    if (CompanionClientService.getClient() && CompanionClientService.getClient().connectionChannel) {
                        return CompanionClientService.getClient().connectionChannel.wasConnectedByQuickHandshake();
                    } else {
                        return false;
                    }
                };
            }
        };
    }])
    .directive('shareButton', [
        '$rootScope',
        'SignalProvider',
        'AppConstants',
        function shareButton($rootScope: RootScope, SignalProvider, AppConstants) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/share_button.html',
            scope: {
                enabled: '<',
                resource: '<',
                resourceType: '<',
                isCurrentFolder: '<',
                shareFolderByInviteHandler: '&onShareFolderByInvite',
                shareAFolderLinkHandler: '&onShareAFolderLink',
                shareFileByInviteHandler: '&onShareFileByInvite',
                shareAFileLinkHandler: '&onShareAFileLink',
                showPermissionPanelHandler: '&onPermissionClicked'
            },
            link: function($scope, $element, attrs) {
                $scope.rightTabTypes = AppConstants.RightTabTypes;
                $scope.isOrgWideLinkSharingEnabled = AppConstants.ORG_WIDE_SHARING_SCOPE !== 'NONE';
            }
        };
    }])
    .directive('fileActionButton', [
        '$rootScope',
        '$translate',
        'authenticatedUser',
        'AppConstants',
        'ResourceService',
        function fileActionButton($rootScope: RootScope, $translate, authenticatedUser, AppConstants, ResourceService) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/file_action_button.html',
            scope: true,    // do not have isolated scope due to the fact that it uses too many functions in its parent scope
            link: function($scope, $element, attrs) {
                attrs.$observe('enabled', function(enabled) {
                    $scope.enabledByAttr = (enabled === true || enabled === "true")? true: false;
                    $scope.enabled = $scope.enabledByAttr && $scope.enabledByDocReadiness;
                });

                /* Open containing folder button */
                $scope.getParentFolderURL = function(resource) {
                    var parentFolderId = resource.ParentFolderId;
                    var userInfo = authenticatedUser.getUserInfo();
                    var hightlightQuery = '?fromSearch=true&highlightResourceId=' + resource.Id;
                    if (parentFolderId === userInfo.RootFolderId) {
                        return '#/mydocs' + hightlightQuery;
                    } else if (parentFolderId === userInfo.RecoveryFolderId) {
                        return '#/recovery' + hightlightQuery;
                    } else if (parentFolderId === userInfo.RecycleBinFolderId) {
                        return '#/recycle' + hightlightQuery;
                    } else {
                        return '#/folder/' + parentFolderId + hightlightQuery;
                    }
                };

                /* open button */
                $scope.openClickedHandler = function() {
                    $rootScope.goto('/document/' + $scope.document.Id);
                };

                /* should show create approvals */
                $scope.isCreateApprovalButtonVisible = function (resource) {
                    return isCreateApprovalButtonVisible(resource, $scope, $rootScope, authenticatedUser);
                }

                /* Create Approval button */
                $scope.createApproval = function (resourceId) {
                    const uri = getCreateApprovalURIPrefix();
                    window.open(uri + "/file/" + resourceId, '_blank');
                }

                /* rename button */
                $scope.renameButtonDisabledReason = function(doc) {
                    // If there is no reason to disable the button, the function returns null and the button should be active
                    if ($scope.isUploading(doc)) {
                        return $translate.instant('MESSAGES.FOLDER_UPLOAD.RENAME_WHILE_UPLOADING');
                    } else if ($scope.isDocumentCheckedOutByAnApp(doc)) {
                        return $translate.instant('MESSAGES.FILE_UPLOAD.RENAME_WHILE_LIVE_EDITING');
                    } else {
                        return null;
                    }
                };

                $scope.isRenameButtonActive = function(doc) {
                    return !$scope.renameButtonDisabledReason(doc);
                }

                /* lock button */
                $scope.showLockOption = function() {
                    var isFileOwner = ResourceService.getOwnerId($scope.document) === authenticatedUser.getUserInfo().Id;
                    var showRequestCheckinOption = $scope.userActionsMap[$scope.document.Id].canRequestCheckin;
                    return isFileOwner || !showRequestCheckinOption;
                };

                $scope.lockButtonClickedHandler = function(doc) {
                    if ($scope.isBasicUser || $scope.isMinimalUser) {
                        return;
                    }

                    if ($scope.userActionsMap[doc.Id].canCheckout) {
                        $scope.checkoutDocument(doc)
                        return;
                    }

                    if ($scope.userActionsMap[doc.Id].canCheckin || $scope.userActionsMap[doc.Id].canForceCheckin || $scope.isDocumentCheckedOutByAnApp(doc.Id)) {
                        $scope.releaseLock(doc)
                        return;
                    }
                };

                /* Setting button */
                $scope.isSettingsOptionVisible = function() {
                    // Do not show setings in search view because no options is available under settings in search view
                    // Do not show settngs for guest user
                    return $scope.layout.view !== AppConstants.ViewTypes.SEARCH_TYPE && !authenticatedUser.getUserInfo().MinimalUser;
                };

                $scope.isMoreOptionVisible = function() {
                    // Do not show more for guest user
                    return !authenticatedUser.getUserInfo().MinimalUser;
                };

                $scope.isRemoveFromShareOptionVisible = function() {
                    return !authenticatedUser.getUserInfo().MinimalUser;
                };

                /* General */
                $scope.leftAlignSubmenu = function() {
                    // Left align submenu when there is no upload button to prevent
                    // the submenu overflow to the window
                    return !$scope.showUploadButton;
                };
                // $scope.document must have value in order for showing the dropdown
                // $evalAsync in multiSelect may trigger the evaluation even before the link function runs.
                // In that case $scope.document is not defined by the time of evaluation.
                $scope.$watch('document', function(newVal) {
                    if (!!newVal) {
                        $scope.enabledByDocReadiness = true;
                        $scope.enabled = $scope.enabledByAttr && $scope.enabledByDocReadiness;
                    }
                });
                $scope.$watch('selectedItems[0]', function(newVal) {
                    if (!!newVal) {
                        $scope.document = $scope.selectedItems[0].item;
                    }
                });
            }
        };
    }])
    .directive('folderActionButton', [
        '$rootScope',
        'authenticatedUser',
        function folderActionButton($rootScope: RootScope, authenticatedUser: any) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/folder_action_button.html',
            scope: true,    // do not have isolated scope due to the fact that it uses too many functions in its parent scope
            link: function($scope, $element, attrs) {
                attrs.$observe('enabled', function(enabled) {
                    $scope.enabled = (enabled === true || enabled === "true")? true: false;
                });

                $scope.leftAlignSubmenu = function() {
                    return !$scope.showUploadButton;
                };

                /* should show create approvals */
                $scope.isCreateApprovalButtonVisible = function (resource) {
                    return isCreateApprovalButtonVisible(resource, $scope, $rootScope, authenticatedUser);
                }

                /* Create Approval button */
                $scope.createApproval = function (resourceId) {
                    const uri = getCreateApprovalURIPrefix();
                    window.open(uri + "/folder/" + resourceId, '_blank');
                }

                $scope.getParentFolderURL = function(resource) {
                    var parentFolderId = resource.ParentFolderId;
                    var userInfo = authenticatedUser.getUserInfo();
                    var hightlightQuery = '?fromSearch=true&highlightResourceId=' + resource.Id;
                    if (parentFolderId === userInfo.RootFolderId) {
                        return '#/mydocs' + hightlightQuery;
                    } else if (parentFolderId === userInfo.RecoveryFolderId) {
                        return '#/recovery' + hightlightQuery;
                    } else if (parentFolderId === userInfo.RecycleBinFolderId) {
                        return '#/recycle' + hightlightQuery;
                    } else {
                        return '#/folder/' + parentFolderId + hightlightQuery;
                    }
                };

                $scope.isRemoveFromShareOptionVisible = function() {
                    return !authenticatedUser.getUserInfo().MinimalUser;
                };

                $scope.isMoreOptionVisible = function() {
                    return !authenticatedUser.getUserInfo().MinimalUser;
                };

                $scope.$watch('selectedItems[0]', function(newVal) {
                    if (!!newVal) {
                        $scope.folder = $scope.selectedItems[0].item;
                    }
                });
            }
        };
    }])
    .directive('currentFolderActionButton', [
        '$rootScope',
        function currentFolderActionButton($rootScope: RootScope) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/current_folder_action_button.html',
            scope: true,    // do not have isolated scope due to the fact that it uses too many functions in its parent scope
            link: function($scope, $element, attrs) {
                attrs.$observe('enabled', function(enabled) {
                    $scope.enabled = (enabled === true || enabled === "true")? true: false;
                });
            }
        };
    }])
    .directive('uploadButton', [
        '$rootScope',
        function uploadButton($rootScope: RootScope) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/upload_button.html',
            scope: {
                enabled: '&',
                fileManagerInstance: '='
            },
            link: function($scope, $element, attrs) {
                $scope.applyActiveStyle = function() {
                    if ($scope.fileManagerInstance && $scope.fileManagerInstance.getTotalSelectedItemCount() > 0) {
                        return false;
                    }
                    // default is active style (blue)
                    return true;
                };

                $scope.isInputDirSupportedFn = function() {
                    var tmpInput = document.createElement('input');
                    if ('webkitdirectory' in tmpInput ||
                        'mozdirectory' in tmpInput ||
                        'odirectory' in tmpInput ||
                        'msdirectory' in tmpInput ||
                        'directory' in tmpInput) return true;

                    return false;
                };

                $scope.isInputDirSupported = $scope.isInputDirSupportedFn();
            }
        };
    }])
    .directive('newButton', [
        '$rootScope',
        '$filter',
        '$routeParams',
        'authenticatedUser',
        'ClientMetricsService',
        'FileUploadService',
        'MessageManager',
        'MessageProvider',
        'ApprovalDetailsService',
        'SignalProvider',
        '$location',
        '$timeout',
        function newButton($rootScope: RootScope, $filter, $routeParams, authenticatedUser, ClientMetricsService,
                           FileUploadService, MessageManager, MessageProvider, ApprovalDetailsService: ApprovalDetailsService, SignalProvider,
                           $location: ng.ILocationService, $timeout) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/new_button.html',
            scope: true,    // do not have isolated scope due to the fact that it uses too many functions in its parent scope
            link: function($scope, $element, attrs) {
                $scope.createNewFile = function(type) {
                    // set folder view to loading state only when it is applicable
                    if ($scope.folderState) {
                        $scope.folderState.loaded = false;
                    }

                    var promise;
                    var dateString = $filter('date')(new Date(), 'MMM d, y h-mm-ss a');
                    var parentFolderId = null;
                    // determine parent folder id
                    if ($routeParams.folderId && $scope.fileManagerInstance) {
                        if ($scope.fileManagerInstance.hasRightForFolder(AppConstants.Permissions.UPLOAD)) {
                            parentFolderId = $routeParams.folderId;
                        } else {
                            parentFolderId = authenticatedUser.getUserInfo().RootFolderId;
                        }
                    } else {
                        parentFolderId = authenticatedUser.getUserInfo().RootFolderId;
                    }
                    switch(type) {
                        case 'docx':
                            promise = FileUploadService.newDocumentFile(parentFolderId, "New Document - " + dateString + ".docx");
                            break;
                        case 'pptx':
                            promise = FileUploadService.newPresentationFile(parentFolderId, "New Presentation - " + dateString + ".pptx");
                            break;
                        case 'xlsx':
                            promise = FileUploadService.newSpreadsheetFile(parentFolderId, "New Spreadsheet - " + dateString + ".xlsx");
                            break;
                    }
                    if (!promise) {
                        return;
                    }
                    promise.then(function(docMetadata) {
                        $scope.onlineEditingDocumentId = docMetadata.Id;
                        openInHancom(docMetadata);
                    }, function(failResult) {
                        $scope.folderState.loaded = true;
                        var NAME_INVALID = 'Names cannot include';
                        var data = failResult.data;
                        // Add an error for file creation failure to the notification list.
                        if (data && data.message && data.message.indexOf('EntityAlreadyExistsException') >= 0) {
                         MessageManager.addErrorMessage(MessageProvider.fileCreateFailAlreadyExists(data.result.config.data.DocumentName));
                        } else if (data && data.message && data.message.indexOf('EntityNotExistsException') >= 0) {
                         MessageManager.addErrorMessage(MessageProvider.fileCreateFailNotExists);
                        } else if (data && data.message && data.message.includes(NAME_INVALID)) {
                         MessageManager.addErrorMessage(MessageProvider.renameInvalidName);
                        } else {
                         MessageManager.addErrorMessage(MessageProvider.fileCreateFailDefault);
                        }
                    });
                };

                $scope.createQuickNotes = function(){
                    var promise;
                    var dateString = $filter('date')(new Date(), 'MMM d, y h-mm-ss a');

                    promise = FileUploadService.newNotesFile(authenticatedUser.getUserInfo().NoteInfo.NoteFolderId , authenticatedUser.getUserInfo().RootFolderId, "Note - " + dateString + ".docx");
                    promise.then(function(data) {
                        authenticatedUser.getUserInfo().NoteInfo.LastActiveNoteId = data.Id;
                        if ($scope.folderState.view !== AppConstants.ViewTypes.NOTE_TYPE) {
                            $rootScope.goto("/myNote")
                        } else {
                            $rootScope.$broadcast(SignalProvider.Folder.SyncCurrentView);
                            $scope.openNewNote(data);
                        }

                    }, function() {
                        MessageManager.addErrorMessage("Could not create the file. Please try again!");
                    });
                };

                $scope.createNewApproval = function() {
                    ApprovalDetailsService.initService();
                    ApprovalDetailsService.setPanelVisibility(true);
                    if (!$scope.viewSupportsNewApprovals($scope.layout.view)) {
                        //The user is not currently in folder view. First take him there and trigger new approval request flow
                        $location.url("/mydocs");
                    } else {
                        $rootScope.$broadcast(SignalProvider.Sidebar.ShowRight, AppConstants.RightTabTypes.NEW_APPROVAL_REQUEST_TAB);
                    }
                };

                $scope.showCreateNoteButton = function() {
                    // return authenticatedUser.getUserInfo() && !authenticatedUser.getUserInfo().MinimalUser;
                    return authenticatedUser.getUserInfo() && !authenticatedUser.getUserInfo().MinimalUser &&
                        $scope.isFeatureEnabled(Features.DocumentViewer.ONLINENOTES) && $scope.onlineEditingEnabled;
                }

                $scope.showApprovalButton = function() {
                    return authenticatedUser.getUserInfo() && !authenticatedUser.getUserInfo().MinimalUser &&
                        $scope.isFeatureEnabled(Features.UI.APPROVAL);
                }

                $scope.showCreateNewFileButtons = function() {
                    return authenticatedUser.getUserInfo() && !authenticatedUser.getUserInfo().MinimalUser &&
                        $scope.isFeatureEnabled(Features.DocumentViewer.ONLINEEDITING) && $scope.onlineEditingEnabled;
                }

                $scope.showCreateNewFolderButton = function() {
                    return authenticatedUser.getUserInfo() && !authenticatedUser.getUserInfo().MinimalUser;
                }

                $scope.isNewButtonEnabled = function() {
                    return $scope.showCreateNewFolderButton() || $scope.showCreateNewFileButtons() || $scope.showCreateNoteButton();
                }

                function openInHancom(doc) {
                    $scope.goto('/document/' + doc.Id+ '?editOnline=true');
                    var event = {
                        name: "DROPDOWN_EDIT_ONLINE",
                        documentId : doc.Id,
                        versionId : doc.VersionMetadata.VersionId
                    };
                    ClientMetricsService.addEventToSession(event);
                };

                $scope.newFolderKeyDownHandler = function(event) {
                    var KEYCODE_ENTER = 13;
                    if (event.which === KEYCODE_ENTER) {
                        $timeout(function(){
                            event.target.querySelector('span').click();
                        }, 0);
                    }
                }
            }
        };
    }])
    .directive('deleteButton', [
        '$rootScope',
        'AppConstants',
        function deleteButton($rootScope: RootScope, AppConstants) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/delete_button.html',
            scope: {
                enabled: '<',
                selectedItemCount: '<',
                onClicked: '&'
            },
            link: function($scope, $element, attrs) {
                $scope.isdeleteLimitExcessed = function() {
                    return $scope.selectedItemCount > AppConstants.LIMITS.CONCURRENT_OPERATION;
                };
            }
        };
    }])
    .directive('restoreButton', [
        '$rootScope',
        'AppConstants',
        function restoreButton($rootScope: RootScope, AppConstants) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/restore_button.html',
            scope: {
                enabled: '<',
                selectedItemCount: '<',
                onClicked: '&'
            },
            link: function($scope, $element, attrs) {
                $scope.isdeleteLimitExcessed = function() {
                    return $scope.selectedItemCount > AppConstants.LIMITS.CONCURRENT_OPERATION;
                };
            }
        };
    }])
    .directive('sharedByMeButton', [
        '$rootScope',
        '$translate',
        function sharedByMeButton($rootScope: RootScope, $translate) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/shared_by_me_button.html',
            scope: {
                currentFilter: '=',
                onFilterClicked: '&'
            },
            link: function($scope, $element, attrs) {
                $scope.sharedByMeCategory = {
                    ALL: null,
                    SHARED_WITH_ME : 'SHARED_WITH_ME',
                    SHAREABLE_LINK : 'SHAREABLE_LINK',
                    ANONYMOUS_LINK : 'ANONYMOUS_LINK'
                };

                $scope.getFilterText = function(sharedByMeFilter) {
                    switch (sharedByMeFilter.resourceCategory) {
                        case $scope.sharedByMeCategory.ALL:
                            return $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_ALL');
                        case $scope.sharedByMeCategory.SHARED_WITH_ME:
                            return $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_SHARED_BY_INVITE');
                        case $scope.sharedByMeCategory.SHAREABLE_LINK:
                            return $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_SHAREABLE_LINK');
                        case $scope.sharedByMeCategory.ANONYMOUS_LINK:
                            return $translate.instant('MODAL.SHARED_RESOURCE_MODAL.FILTER_CATEGORY_ANONYMOUS_LINK');
                        default:
                            return null;
                    }
                }
            }
        };
    }])
    .directive('deleteLinkButton', [
        '$rootScope',
        function deleteLinkButton(){
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/delete_link_button.html',
            scope: {
              enabled: '<',
              selectedItemCount: '<',
              onClicked: '&'
            },
            link: function($scope, $element, attrs) {
                $scope.isdeleteLimitExcessed = function() {
                    return $scope.selectedItemCount > AppConstants.LIMITS.CONCURRENT_OPERATION;
                };
            }
        }
    }])
    .directive('multiSelectActionButton', [
        '$rootScope',
        'CompanionService',
        function multiSelectActionButton($rootScope, CompanionService){
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/multi_select_action_button.html',
            link: function($scope, $element, attrs) {
                attrs.$observe('enabled', function(enabled) {
                    $scope.enabled = (enabled === true || enabled === "true")? true: false;
                });

                $scope.downlaodSelectedResources = (selectedItems: ISelectedItem[]) => {
                    let selectedFiles = [];
                    let selectedFolders = [];
                    selectedItems.forEach((selectedItem: ISelectedItem) => {
                        if (selectedItem.type === 'DOCUMENT') {
                            selectedFiles.push(selectedItem.item);
                        } else if (selectedItem.type === 'FOLDER') {
                            selectedFolders.push(selectedItem.item);
                        }
                    });

                    CompanionService.downloadFoldersAndFiles(selectedFiles, selectedFolders);
                };

                $scope.isMoveButtonVisible = () => {
                    return $scope.isFeatureEnabled($scope.Features.UI.EXT_MULTI_SELECT_ACTIONS_IN_FILE_BROWSER) 
                        && $scope.layout.view !== AppConstants.ViewTypes.SEARCH_TYPE 
                        && $scope.layout.view !== AppConstants.ViewTypes.SHARED_TYPE;
                };
            }
        }
    }])
    .directive('requestAccessButton', [
        '$rootScope',
        '$uibModal',
        'AppConstants',
        function requestAccessButton($rootScope: RootScope, $uibModal, AppConstants) {
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/request_access_button.html',
            scope: {
                enabled: '<',
                resourceId: '<',
            },
            link: function($scope, $element, attrs) {
                $scope.showAccessRequestMocal = function() {
                    var accessRequestModal = $uibModal.open({
                        templateUrl: './tasks/access_request/accessRequestModal.html',
                        controller: 'accessRequestModalCtrl',
                        size: 'md',
                        resolve: {
                            TargetResourceId: function() {
                                return $scope.resourceId;
                            }
                        }
                    });

                    $scope.$on("$destroy", function() {
                        if (accessRequestModal) {
                            accessRequestModal.close();
                        }
                    });
                };
            }
        };
    }])
    .directive('addToApprovalButton', [
        '$rootScope',
        'ApprovalUtils',
        'ApprovalDetailsService',
        function addToApprovalButton($rootScope: ng.IRootScopeService, ApprovalUtils: IApprovalUtils, ApprovalDetailsService: ApprovalDetailsService){
        return {
            restrict: 'E',
            templateUrl: './top-nav/buttons/add_to_approval_button.html',
            scope: {
              enabled: '<',
              selectionManager: '='
            },
            link: function($scope, $element, attrs) {
                attrs.$observe('enabled', function(enabled) {
                    $scope.enabled = (enabled === true || enabled === "true")? true: false;
                });

                $scope.isClickable = function() {
                    return $scope.enabled && ApprovalDetailsService.isResourceModificationAllowed() && $scope.selectionManager.getTotalSelectedItemCount() > 0;
                };

                $scope.addSelectedResourcesToApproval = function() {
                    $scope.selectionManager.getSelectedItems().forEach((selectedItem) => {
                        if (selectedItem.type === AppConstants.ResourceTypes.FILE) {
                            ApprovalDetailsService.appendApprovalResource(ApprovalUtils.fileMetadata2ApprovalResource(selectedItem.item));
                        }
                        if (selectedItem.type === AppConstants.ResourceTypes.FOLDER) {
                            ApprovalDetailsService.appendApprovalResource(ApprovalUtils.folderMetadata2ApprovalResource(selectedItem.item));
                        }
                    });
                };

                $scope.isResourceModificationAllowed = ApprovalDetailsService.isResourceModificationAllowed;
            }
        }
    }]);
